import React from "react";
import { FaCoins, FaCubes, FaGamepad, FaGlobe, FaLink } from "react-icons/fa";

function Web3GameFeatures() {
  const reasons = [
    {
      title: "Decentralized Gaming Infrastructure",
      desc: "We build games on decentralized networks, ensuring that players have full ownership and control over their in-game assets. This transparency promotes fair play and provides a more immersive and secure experience for users.",
      icon: <FaGamepad size={35} />,
    },
    {
      title: "NFT and Digital Asset Integration",
      desc: "Our team incorporates NFTs and digital assets, allowing players to trade, sell, and monetize unique items they acquire or create. Xeer Technology’s NFT integration ensures secure, verifiable ownership and enhances in-game economies.",
      icon: <FaCubes size={35} />,
    },
    {
      title: "Play-to-Earn (P2E) Models",
      desc: "Revolutionize your game’s economy with play-to-earn models that reward users with cryptocurrency or in-game tokens. Xeer Technology’s P2E solutions create real value for players, fostering engagement and loyalty.",
      icon: <FaCoins size={35} />,
    },
    {
      title: "Metaverse Interactivity",
      desc: "Enter the future of gaming with metaverse-ready features, where players can explore interconnected virtual worlds. We develop immersive experiences, customizable avatars, and social interaction tools, bringing life to virtual worlds.",
      icon: <FaGlobe size={35} />,
    },
    {
      title: "Multi-Chain and Cross-Chain Compatibility",
      desc: "We build Web3 games that are compatible with various blockchain platforms, including Ethereum, BNB Chain, Solana, and more. Our multi-chain solutions give players the freedom to interact across ecosystems, increasing the value and usability of in-game assets.",
      icon: <FaLink size={35} />,
    },
  ];

  return (
    <div
      className="services-area pt-120 pb-120 mt-5"
      style={{ background: "#ffffff" }}
    >
      <div className="container text-center">
        <h2
          className="title fw-extrabold mb-4"
        // style={{ fontSize: "40px", letterSpacing: "-1px" }}
        >
          Key Highlights of our Web3 Game Development Service

        </h2>

        <p
          className="mt-2 mb-5 mx-auto text-muted fs-5"
          style={{ maxWidth: "800px" }}
        >
          By harnessing blockchain technology, our team empowers developers and players alike with innovative gaming ecosystems that offer true ownership, play-to-earn models, and engaging metaverse integrations!


        </p>

        <div className="row g-4 justify-content-center">
          {reasons.map((reason, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="reason-card border-0 p-5 text-center h-100"
                style={{
                  borderRadius: "32px",
                  background: "#f9faff",
                  border: "1px solid #f0f3ff",
                  transition: "all 0.4s ease",
                  cursor: "default",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.background = "#ffffff";
                  e.currentTarget.style.boxShadow =
                    "0 25px 50px rgba(0, 0, 0, 0.04)";
                  e.currentTarget.style.borderColor = "#3366ff20";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "#f9faff";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#f0f3ff";
                }}
              >
                <div
                  className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: "70px",
                    height: "70px",
                    fontSize: "28px", // untouched
                    backgroundColor: "#ffffff",

                    borderRadius: "20px",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                  }}
                >
                  {reason.icon}
                </div>

                <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
                  {reason.title}
                </h5>

                <p
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    lineHeight: "1.7",
                    marginBottom: 0,
                  }}
                >
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Web3GameFeatures;
